import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { dmUnreadCount } from "@/lib/api";

/* TopNav Messages button with a live unread badge (polls every ~20s). */
export function MessagesBell() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [unread, setUnread] = useState(0);
  const timerRef = useRef(null);

  const load = useCallback(async () => {
    try { const d = await dmUnreadCount(); setUnread(d.unread || 0); } catch { /* quiet */ }
  }, []);

  useEffect(() => {
    if (!user) return undefined;
    load();
    timerRef.current = setInterval(load, 20000);
    return () => clearInterval(timerRef.current);
  }, [user, load]);

  if (!user) return null;

  return (
    <button
      onClick={() => navigate("/messages")}
      data-testid="nav-messages-button"
      aria-label="Messages"
      title="Messages"
      className="relative inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/10 bg-white/[0.03] text-muted-foreground transition-colors hover:border-gold-light/40 hover:text-foreground"
    >
      <MessageSquare className="h-4.5 w-4.5" />
      {unread > 0 ? (
        <span
          data-testid="nav-messages-unread-badge"
          className="absolute -right-1 -top-1 inline-flex h-4 min-w-[16px] items-center justify-center rounded-full px-1 text-[10px] font-bold text-[#05070B]"
          style={{ backgroundColor: "#D8B66A" }}
        >
          {unread > 9 ? "9+" : unread}
        </span>
      ) : null}
    </button>
  );
}
